module.exports = __webpack_public_path__ + "static/20-8-a2b3fd5d9567f5bdbdfd6d98dd388053.jpg";